var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsDropdownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 11.4L13 9.8V8C13 5 10.8 2.6 8 2.1C8 2.1 8 2.1 8 2V1C8 0.5 7.5 0 7 0C6.5 0 6 0.4 6 1V2C6 2 6 2 6 2.1C3.2 2.6 1 5 1 8V9.8L0.1 11.6C0.1 11.6 0.1 11.6 0.1 11.7C2.23517e-08 11.8 0 11.9 0 12C0 12.1 2.23517e-08 12.2 0.1 12.3V12.4C0.1 12.4 0.1 12.4 0.1 12.5L0.2 12.6C0.2 12.6 0.2 12.7 0.3 12.7C0.4 12.8 0.5 12.8 0.5 12.9H0.6C0.8 13 0.9 13 1 13H4C4 14.8 5.6 16 7 16C7.8 16 8.6 15.7 9.1 15.1C9.7 14.5 10 13.8 9.9 13H12.9C13.5 13 13.9 12.6 13.9 12C14 11.8 13.9 11.6 13.8 11.4ZM2.9 10.4C3 10.3 3 10.2 3 10H11C11 10.2 11 10.3 11.1 10.4L11.4 11H9H5H2.6L2.9 10.4ZM7 4C9.2 4 11 5.8 11 8H3C3 5.8 4.8 4 7 4ZM8 13.1C8 13.4 7.8 13.6 7.7 13.7C7.5 13.9 7.3 14 7 14C6.6 14 6 13.6 6 13L8 13.1Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsDropdownIcon);
export default __webpack_public_path__ + "static/media/notifications-dropdown-icon.3c64b118cf785eb557d3d7e26665bed1.svg";
export { ForwardRef as ReactComponent };